module.exports = __webpack_public_path__ + "static/media/error_black.a3c7c882.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/error_black.svg
// module id = 3093
// module chunks = 0